import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';
import {MessageBox, Message} from 'element-ui';
import VueLocalStorage from 'vue-localstorage'
import {getLanguage} from "@/utils/i18n";
import i18n from '@/utils/i18n'

Vue.use(VueLocalStorage)

// 获取当前域名并处理 baseURL
const getCurrentDomain = () => {
    const hostname = window.location.hostname;
    let baseUrl = Vue.localStorage.get('api_base_url') || process.env.VUE_APP_BASE_API;

    // 检查当前域名是否以 ga 开头的二级域名
    const domainParts = hostname.split('.');
    if (domainParts.length >= 3 && domainParts[0].startsWith('ga')) {
        console.log('new baseURL fetch 1');
        // 如果原始 baseURL 是完整 URL
        if (baseUrl.includes('://')) {
            console.log('new baseURL fetch 2');
            try {
                const urlObj = new URL(baseUrl);
                const urlParts = urlObj.hostname.split('.');

                // 将 baseURL 的二级域名替换为 ga 开头
                if (urlParts.length >= 3) {
                    console.log('new baseURL fetch 3');
                    urlParts[0] = 'ga' + urlParts[0]; // 使用当前域名的二级域名前缀
                    urlObj.hostname = urlParts.join('.');
                    baseUrl = urlObj.toString();
                    console.log('new baseURL:', baseUrl);
                }
            } catch (e) {
                console.error('解析 baseURL 失败:', e);
            }
        }
    }

    return baseUrl;
};

// 全局配置
axios.defaults.baseURL = getCurrentDomain();
axios.defaults.timeout = 180000;

// 请求前的配置
axios.interceptors.request.use(
  config => {
    // 如果已经登录需要注入 token
    // 从 sessionStorage 读取 token（关闭浏览器后自动清除）
    let token = sessionStorage.getItem('token');
    if (token) {
      config.headers.common['S-Token'] = token;
    }

    // 如果调用方已显式声明 Content-Type 为 JSON，则保留原始数据，让 axios 自动序列化
    const explicitContentType = config.headers?.['Content-Type'] || config.headers?.common?.['Content-Type']
    const isJsonRequest = explicitContentType === 'application/json'

    if (!isJsonRequest) {
      // 默认将 POST/PUT 请求体转为 form 表单格式
      config.data = qs.stringify(config.data, {arrayFormat: 'repeat'})
      if (config.method === 'post' || config.method === 'put') {
        config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
      }
    }

    config.headers['Accept-Language'] = getLanguage()

    try {
      const supportUsers = JSON.parse(sessionStorage.getItem('supportUsers') || '[]')
      if (supportUsers.length) {
        const ids = supportUsers.map(u => u.id).filter(Boolean).join(',')
        if (ids) {
          if (!config.params) config.params = {}
          config.params.supportUserIds = ids
        }
      }
    } catch (e) { /* ignore */ }

    return config;
  },
  error => {
    console.log(error)
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    if (response.data.code === 4) {
        MessageBox.confirm(i18n.t('base.login_expired'), i18n.t('base.tip'), {
            confirmButtonText: i18n.t('login.relogin'),
            showCancelButton: true,
            closeOnClickModal: false,
            closeOnPressEscape: true,
            showClose: false,
            type: 'warning'
        }).then(() => {
            // 清除 sessionStorage 中的所有登录信息
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('user')
            sessionStorage.removeItem('username')
            sessionStorage.removeItem('nickname')
            sessionStorage.removeItem('supportUsers')
            window.location.reload(true)
        });
        return Promise.reject(new Error(i18n.t('base.login_expired')));
    } else if (response.data.code !== 0) {
      Message({
        message: response.data.msg,
        type: 'error'
      });
      return Promise.reject(new Error(response.data.msg));
    }

    return response.data.data;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default axios;
